import type { OTCFieldsData } from '@src/types/OTC/otcProductBuilderTypes';
import type { DealBookingType } from '@src/types/OTC/otcSharedTypes';
import { getRequiredFieldsV1, type RequiredFieldsMap } from '@talos/kyoko';

import { loanOtcFieldsSchema } from '../productDefinitions/FixedRateLoanProductBuilderSliceStrategy';
import { floatingRateLoanOtcFieldsSchema } from '../productDefinitions/FloatingRateLoanProductBuilderSliceStrategy';
import { forwardOtcFieldsSchema } from '../productDefinitions/ForwardProductBuilderSliceStrategy';
import { optionOtcFieldsSchema } from '../productDefinitions/OptionProductBuilderSliceStrategy';
import { repoOtcFieldsSchema } from '../productDefinitions/RepoProductBuilderSliceStrategy';

export function getOTCRequiredFieldsV1(productType: DealBookingType, otcFields: OTCFieldsData): RequiredFieldsMap {
  switch (productType) {
    case 'forward':
      return getRequiredFieldsV1(forwardOtcFieldsSchema, otcFields);
    case 'fixedRateLoan':
      return getRequiredFieldsV1(loanOtcFieldsSchema, otcFields);
    case 'floatingRateLoan':
      return getRequiredFieldsV1(floatingRateLoanOtcFieldsSchema, otcFields);
    case 'option':
      return getRequiredFieldsV1(optionOtcFieldsSchema, otcFields);
    case 'repo':
      return getRequiredFieldsV1(repoOtcFieldsSchema, otcFields);
    default: {
      const unsupportedProductType: never = productType;
      throw new Error(`Unsupported OTC product type: ${unsupportedProductType}`);
    }
  }
}
